'use strict';

// a bunch of cool stuff from core-js (see README for more info)
require('./es6.min');

// Function.prototype.bind support
// basically just for old Safari
if (!Function.prototype.bind) {
	Function.prototype.bind = function (oThis) {
		if (typeof this !== 'function') {
			// closest thing possible to the ECMAScript 5 internal IsCallable function
			throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
		}

		var aArgs = Array.prototype.slice.call(arguments, 1),
			fToBind = this,
			fNOP = function () {},
			fBound = function () {
				return fToBind.apply(this instanceof fNOP && oThis
						? this
						: oThis,
					aArgs.concat(Array.prototype.slice.call(arguments)));
			};

		fNOP.prototype = this.prototype;
		fBound.prototype = new fNOP();

		return fBound;
	};
}


// Promise.prototype.finally support
// Spec: https://github.com/tc39/proposal-promise-finally
if (!Promise.prototype['finally']) {
	Promise.prototype['finally'] = function (callback) {
		var self = this;
		return this.then(
			function (value) {
				return self.constructor.resolve(callback()).then(function () {
					return value;
				})
			},
			function (reason) {
				return self.constructor.resolve(callback()).then(function () {
					return self.constructor.reject(reason);
				})
			}
		)
	};
}


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/consumerweb-shim/index.js
// module id = 208
// module chunks = 1 4 6